<div class="form-floating">
  <div class="label-sm pl-0 text-wrap">{{ label() | translate }}</div>
  <div class="fw-bold pt-1" [attr.data-test]="dataTestId()">{{ value() | translate }}</div>
</div>
